/**
 * Gets the current parameter value from url
 *
 * @param   {string}  param    The url parameter to get
 * @param   {mixed}   defaultValue  The default value if not exist
 * @return  {mixed}  The current value parameter or default if not exist
 */
window.getCurrentParam = function (param, defaultValue = null) {
    let value        = defaultValue;
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has(param)) {
        value = searchParams.getAll(param);
    }
    return value;
}

/**
 * Sets the current parameter value to url
 *
 * @post    The new parameter sets generate a new history in the web browser
 * @param   {string}  param      The url parameter
 * @param   {string}  newValue   The new value to set
 * @param   {bool}    override   The flag that indicate if the parameter exists override or add as next
 */
window.setCurrentParam = function (param, newValue, override = true) {
    // Obtener la URL actual y los parámetros de búsqueda
    // let url          = window.location.href;
    let searchParams = new URLSearchParams(window.location.search);

    // Comprobar si el parámetro ya existe en la URL
    if (!override) {
        // Añadir un nuevo parámetro a la URL
        let valores = searchParams.getAll(param);

        // Recorrer los valores y reemplazarlos por el nuevo valor
        let founded = false;
        valores.forEach(function (currentValue, index) {
            if (currentValue === newValue) {
                founded = true;
            }
        });

        // Añadir un nuevo parámetro a la URL
        if (!founded) {
            searchParams.append(param, newValue);
        }
    } else {
        if (searchParams.has(param)) {
            // Actualizar el valor del parámetro existente
            searchParams.set(param, newValue);
        } else {
            // Añadir un nuevo parámetro a la URL
            searchParams.append(param, newValue);
        }
    }

    // Construir la URL actualizada con los parámetros
    let updatedURL = window.location.href.split('?')[0] + '?' + searchParams.toString();

    // Actualizar la URL en el historial del navegador sin recargar la página
    window.history.pushState({path: updatedURL}, '', updatedURL);

    // history.replaceState({}, "", `?${searchParams.toString()}`); // Solo cambia los parámetros de la url pero no lo mete en el historial
}

/**
 * Deletes the current parameter from url
 * @pre     If the oldValue is null, all param values will be removed
 *
 * @post    The new parameter sets generate a new history in the web browser
 * @param   {string}  param      The url parameter
 * @param   {string}  oldValue   The new value to set
 */
window.deleteCurrentParam = function (param, oldValue = null) {
    // Obtener la URL actual y los parámetros de búsqueda
    let searchParams = new URLSearchParams(window.location.search);

    // Comprobar si el parámetro ya existe en la URL
    if (null === oldValue) {
        searchParams.delete(param);
    } else {
        searchParams = removeValue(searchParams, param, oldValue);
    }

    // Construir la URL actualizada con los parámetros
    let updatedURL = window.location.href.split('?')[0] + '?' + searchParams.toString();

    // Actualizar la URL en el historial del navegador sin recargar la página
    window.history.pushState({path: updatedURL}, '', updatedURL);

    // history.replaceState({}, "", `?${searchParams.toString()}`); // Solo cambia los parámetros de la url pero no lo mete en el historial
}

window.removeValue = function (searchParams, param, oldValue) {
    const values = searchParams.getAll(param);
    if (values.length) {
        searchParams.delete(param);
        for (const value of values) {
            if (value !== oldValue) {
                searchParams.append(param, value);
            }
        }
    }
    return searchParams;
};
